/*
  BluFood Hinweisleiste (sections/bf-announcement.liquid)
  - Mobil: Hinweise wechseln automatisch (pausiert bei Hover/Fokus, aus bei "Bewegung reduzieren")
  - Liefertermin: aus assets/bf-delivery.js
  - Versandfortschritt: aktualisiert sich bei jeder Warenkorb-Aenderung (assets/bf-cart-watch.js)
*/
import { createCalendar, readConfig, toLabel, addDays, zonedNow } from '@bf/delivery'
import { onCartUpdate, fetchCart, freeShipCode } from '@bf/cart-watch'

const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
const money = (cents, trimZeros = false) => {
  const value = cents / 100
  const whole = Number.isInteger(value)
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency,
    minimumFractionDigits: trimZeros && whole ? 0 : 2,
    maximumFractionDigits: 2
  }).format(value)
}

function initDelivery (root) {
  const el = root.querySelector('[data-bf-delivery-text]')
  if (!el) return
  const calendar = createCalendar(readConfig())
  const render = () => {
    const now = new Date()
    const first = calendar.earliest(now)
    if (!first) return
    const { today } = zonedNow(now)
    const isTomorrow = addDays(today, 1).getTime() === first.delivery.getTime()
    const dateText = (isTomorrow ? 'morgen, ' : '') + toLabel(first.delivery)
    const cfg = calendar.config
    const cutoff = `${cfg.cutoff.hour}:${String(cfg.cutoff.minute).padStart(2, '0')}`
    const template = calendar.minutesUntilCutoff(now) !== null ? el.dataset.before : el.dataset.after
    if (template) el.textContent = template.replace('{uhrzeit}', cutoff).replace('{datum}', dateText)
  }
  render()
  setInterval(render, 60000)
}

function initShipping (root) {
  const el = root.querySelector('[data-bf-shipping]')
  if (!el) return
  const threshold = parseInt(el.dataset.threshold, 10) || 0
  const text = el.querySelector('[data-bf-shipping-text]')
  const bar = el.querySelector('[data-bf-shipping-bar]')
  if (!threshold || !text) return
  onCartUpdate((cart) => {
    const total = cart.total_price || 0
    // R61: Gratis-Versand-Code (bzw. Creator-Aktion) -> Versand gratis, auch unter der Schwelle
    const rest = freeShipCode(cart) ? 0 : threshold - total
    if (total === 0) {
      text.textContent = el.dataset.textEmpty.replace('{schwelle}', money(threshold, true))
    } else if (rest > 0) {
      text.textContent = el.dataset.textProgress.replace('{rest}', money(rest))
    } else {
      text.textContent = el.dataset.textDone
    }
    if (bar) {
      bar.style.width = (rest <= 0 ? 100 : Math.min(100, Math.round(total / threshold * 100))) + '%'
      bar.parentElement.classList.toggle('is-hidden', total === 0)
    }
    el.classList.toggle('is-done', rest <= 0 && total > 0)
  })
}

function initRotation (root) {
  const items = Array.from(root.querySelectorAll('[data-bf-announce-item]'))
  if (items.length < 2) return
  const mobile = window.matchMedia('(max-width: 1099px)')
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)')
  const seconds = Math.max(3, parseInt(root.dataset.interval, 10) || 5)
  let index = 0
  let paused = false
  root.addEventListener('mouseenter', () => { paused = true })
  root.addEventListener('mouseleave', () => { paused = false })
  root.addEventListener('focusin', () => { paused = true })
  root.addEventListener('focusout', () => { paused = false })
  setInterval(() => {
    if (!mobile.matches || reduce.matches || paused || document.hidden) return
    items[index].classList.remove('is-active')
    index = (index + 1) % items.length
    items[index].classList.add('is-active')
  }, seconds * 1000)
}

function initAll () {
  document.querySelectorAll('[data-bf-announce]').forEach((root) => {
    if (root.__bfInit) return
    root.__bfInit = true
    initDelivery(root)
    initShipping(root)
    initRotation(root)
  })
}

initAll()
// Theme-Editor: Section neu gerendert
document.addEventListener('shopify:section:load', initAll)
// Zurueck-Button (Seiten-Cache): Warenkorb neu lesen
window.addEventListener('pageshow', (e) => { if (e.persisted) fetchCart().catch(() => {}) })
